export default {
    view: {
        has_insurance_been_obtained: 'Has insurance authorization been obtained?',
        thanks_for_collaboration: 'Thank you for your collaboration!',
        insurance_updated: 'The insurance authorization status has been updated!',
        referral_cancelled: 'The referral has been cancelled.',
        enter_insurance_auth_number: 'Please enter insurance authorization number',
        referral_over: 'This referral is over.',
        footer: "Don't miss the opportunity to connect with highly rated healthcare service providers in your area and beyond.",
        auth_number_label: 'Insurance authorization number',
        auth_number_placeholder: '#authorization number',
        referral_details: 'Referral details:',
        due_date: 'Due on:',

        buttons: {
            sign_up: 'Sign up to medmatch',
            confirm: 'Confirm',
        },
    },
}
